import { render, staticRenderFns } from "./DocMasterView.vue?vue&type=template&id=c96df364&scoped=true&"
import script from "./DocMasterView.vue?vue&type=script&lang=js&"
export * from "./DocMasterView.vue?vue&type=script&lang=js&"
import style0 from "./DocMasterView.vue?vue&type=style&index=0&id=c96df364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96df364",
  null
  
)

export default component.exports